/* eslint-disable consistent-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Device } from '@beef/smart-kit';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import { deviceButtonTitle, deviceVariant } from 'constants/device';
import { getIsItemInBasket } from 'store/common/basket/selectors';
// import { preventDefaultBinder } from 'utils/events';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getDiscount = (price, oldPrice) => {
  if (oldPrice) {
    return Math.floor(((oldPrice - price) * 100) / oldPrice);
  }
};

export const CrossSellDevice = ({ product, onAddToBasket, src }) => {
  const discount = getDiscount(product.price, product?.oldPrice);
  const isSamePrice = product.price === product?.oldPrice;

  const device = {
    slug: product.url,
    id: product.detailsSlugOrId,
    highlight: product?.highlight || null,
    imgOptions: {
      src: product.image.imageUrl,
      alt: product.image.alt,
    },
    name: product.name,
    price: product.price,
    oldPrice: !isSamePrice && product.oldPrice,
    discount: !isSamePrice && discount,
    link: product.url,
  };

  const onClickLink = () => {
    window.location.href = `/shop/details/${product.url}`;
  };

  const redirectToBasket = () => {
    window.location.href = '/basket/';
  };

  // const onOpenModal = () => preventDefaultBinder(onClickLink);
  const isInBasket = useSelector((state) => getIsItemInBasket(state, product?.id?.toString()));
  const handleClickInBasket = () => {
    onAddToBasket({ src, isInBasket: product.isInBasket, productId: product.id, ...product });
  };

  const purchaseData = {
    variant: isInBasket ? deviceVariant.SECONDARY : deviceVariant.TERTIARY,
    title: isInBasket ? deviceButtonTitle.IN_BASKET : deviceButtonTitle.TO_BASKET,
    onClick: isInBasket ? redirectToBasket : handleClickInBasket,
  };
  return (
    <Device
      device={device}
      className={cx(device?.highlight && 'left-border')}
      isWithModal
      onOpenModal={onClickLink}
      purchaseData={purchaseData}
    />
  );
};

CrossSellDevice.propTypes = {
  product: PropTypes.object,
  onAddToBasket: PropTypes.func,
  src: PropTypes.string,
};
